// extracted by mini-css-extract-plugin
module.exports = {"spin":"style_spin__3eWx3"};